'use strict';

/* Dependencies */
var plugins = [require('plugins/window.console'), require('plugins/array.find'), require('plugins/array.last'), require('plugins/array.from'), require('plugins/array.contains'), require('plugins/object.assign'), require('plugins/string.trim'), require('plugins/string.startsWith')];

/* Stylesheets (loaded through WebPack) */
require('../css/main.scss');

var React = require('react');

/* Router */
var router = require('routers/main');

React.initializeTouchEvents(true);

router.run(function (Handler, state) {
  var name = state.routes.last().name;
  var params = state.params;

  React.render(React.createElement(Handler, { name: name, params: params }), document.getElementById('main'));
});


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/main.js
 **/